<template>
  <div id="confirma-doc">
    <h1 class="titulo">{{titulo}}</h1>
    <figure>
      <img class="img-fluid mx-auto cadeado"
           :src="doc"
           :title="titulo"
           :alt="titulo">
    </figure>
    <div  id="footer" class="footer-shadow">
      <button type="button"  v-on:click="callBackSucesso()" class="btn btn-primary btn-lg btn-block">Confirmar e continuar</button>
      <button type="button"  v-on:click="callBackFalha()" class="btn btn-link btn-lg btn-block mt-3">Refazer foto ›</button>
    </div>
  </div>
</template>

<script>

export default {
  name: "DocConfirmacao",
  props:{
    doc: {type: String},
    frente:{type: Boolean}
  },
  data:function (){
    return {
      gtm:{
        'CIN':{
          check:{
            frente:'ConfirmDocCinFront',
            verso:'ConfirmDocCinBack'
          },
          retake:{
            frente:'RetakeDocCinFront',
            verso:'RetakeDocCnhBack'
          }
        },
        'CNH':{
          check:{
            frente:'ConfirmDocCnhFront',
            verso:'ConfirmDocCnhBack'
          },
          retake:{
            frente:'RetakeDocCnhFront',
            verso:'RetakeDocCnhBack'
          }
        },
        'RG':{
          check:{
            frente:'ConfirmDocRgFront',
            verso:'ConfirmDocRgBack'
          },
          retake:{
            frente:'RetakeDocRgFront',
            verso:'RetakeDocRgBack'
          }
        },
        'OUTRO':{
          check:{
            frente:'ConfirmDocOutrosFront',
            verso:'ConfirmDocOutrosBack'
          },
          retake:{
            frente:'RetakeDocOutrosFront',
            verso:'RetakeDocOutrosBack'
          }
        }
      },
      texto:{
        'CNH':'da CNH',
        'CIN': 'da CIN',
        'RG': 'do RG',
        'OUTRO':'do documento'
      }
    }
  },
  methods:{
    callBackSucesso:function (){
      let t = this.$store.getters.tipoDoc;
      let dataGtm = this.gtm[t].check;
      let label = (this.frente) ? dataGtm.frente : dataGtm.verso;
      this.$emit('callBackSucesso');
    },
    callBackFalha:function (){
      let t = this.$store.getters.tipoDoc;
      let dataGtm = this.gtm[t].retake;
      let label = (this.frente) ? dataGtm.frente : dataGtm.verso;
      this.$emit('callBackFalha');
    },
  },
  computed:{
    titulo:function (){
      let t = this.$store.getters.tipoDoc;
      let lado = (this.frente) ? 'da frente'  :  'do verso';
      let doc = this.texto[t];
      return `Confirme se os dados e foto ${lado} ${doc} estão legíveis`;
    },
    textoBotao:function (){
      return (this.frente) ? 'Refazer a foto da frente'  :  'Refazer a foto do verso';
    }
  }
}
</script>

<style scoped>
  #confirma-doc{
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin-top: 80px;
  }
  figure{
    height: auto;
    margin: 0;
    margin-top: 2.5rem;
  }
  img{
    width: 11rem;
    height: 100%;
    object-fit: contain;
    margin: 0 auto;
    display: block;
  }
  @media (max-device-height: 640px) {
   figure{
     height: 14rem;
   }
  }
  @media (max-device-height: 639px){
    figure{
      height: 10rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/DocConfirmacao.vue